import { useQueryHistoryOverlay } from '../context/QueryHistoryOverlayContext';
import { useQueryBuilderOverlay } from '../context/QueryBuilderOverlayContext';
import OverlayTemplate from './common/OverlayTemplate';
import QueryHistoryContent from './query/QueryHistoryContent';

const QueryHistoryOverlay = () => {
  const { isOpen, isMinimized, toggleMinimized } = useQueryHistoryOverlay();
  const { openOverlay: openQueryBuilder } = useQueryBuilderOverlay();

  const handleRunQuery = (queryText) => {
    openQueryBuilder({ initialQuery: queryText });
  };

  const icon = (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );

  return (
    <OverlayTemplate
      isOpen={isOpen}
      isMinimized={isMinimized}
      onClose={toggleMinimized}
      onToggleMinimize={toggleMinimized}
      title="Query History"
      icon={icon}
      minimizedTabText="History"
      width="900px"
      zIndex={54}
      minimizedTabPosition="80%"
    >
      <div className="p-6">
        <QueryHistoryContent showTitle={false} onRunQuery={handleRunQuery} />
      </div>
    </OverlayTemplate>
  );
};

export default QueryHistoryOverlay;
